import { Component, Inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MemberBenefitFlyout } from "src/app/models/enrollment-option";

@Component({
    selector: 'mwp-dialog-deduction-summary',
    templateUrl: './deduction-summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogDeductionSummaryComponent implements OnInit {
    public memberBenefitFlyout: MemberBenefitFlyout;

    constructor(
        private dialogRef: MatDialogRef<DialogDeductionSummaryComponent>,
        @Inject(MAT_DIALOG_DATA) public dialogData: any,
    ) {
    }

    ngOnInit(): void {
        this.memberBenefitFlyout = this.dialogData;
    }

    public closeDialog(): void {
        this.dialogRef.close();
    }
}